<template>
  <div>
    <v-form v-if="!formListLoader">
      <ValidationObserver ref="basicInfoValidationObserver">
        <v-row class="ma-4">
          <v-col
            v-if="formList[482] && formList[482].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="salutationProvider"
              v-slot="{ errors }"
              :name="formList[482].Field_Alias"
              :rules="formList[482].Mandatory_Field == 'Yes' ? 'required' : ''"
            >
              <v-autocomplete
                :id="'Salutation'"
                v-model="salutation"
                outlined
                :items="salutationList"
                required
                @change="salutationListChange"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[482].Field_Alias }}
                  <span
                    v-if="formList[482].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <!-- First Name -->
          <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
            <ValidationProvider
              ref="firstNameProvider"
              v-slot="{ errors }"
              :name="firstNameLabel"
              rules="required|multilingualNameValidation"
            >
              <v-text-field
                :id="'First_Name'"
                v-model="firstName"
                outlined
                :counter="50"
                :maxlength="50"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ firstNameLabel }}
                  <span style="color: red">*</span>
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Middle Name -->
          <v-col
            v-if="formList[695] && formList[695].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="middleNameProvider"
              v-slot="{ errors }"
              :name="formList[695].Field_Alias || 'Middle Name'"
              :rules="
                formList[695].Mandatory_Field == 'Yes'
                  ? 'required|multilingualNameValidation'
                  : 'multilingualNameValidation'
              "
            >
              <v-text-field
                :id="'Middle_Name'"
                v-model="middleName"
                outlined
                :counter="50"
                :maxlength="50"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[695].Field_Alias || "Middle Name" }}
                  <span
                    v-if="formList[695].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Last Name -->
          <v-col
            v-if="formList[696] && formList[696].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="lastNameProvider"
              v-slot="{ errors }"
              :name="formList[696].Field_Alias || 'Last Name'"
              :rules="
                formList[696].Mandatory_Field == 'Yes'
                  ? 'required|multilingualNameValidation'
                  : 'multilingualNameValidation'
              "
            >
              <v-text-field
                :id="'Last_Name'"
                v-model="lastName"
                outlined
                :counter="50"
                :maxlength="50"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[696].Field_Alias || "Last Name" }}
                  <span
                    v-if="formList[696].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Custom Field 1 -->
          <v-col
            v-if="formList[484] && formList[484].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="customField1Provider"
              v-slot="{ errors }"
              :name="formList[484].Field_Alias"
              :rules="
                formList[484].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[484].Min_Validation || 1}|max:${
                      formList[484].Max_Validation || 100
                    }|regex:${formList[484].Validation_Id || 5}`
                  : `min:${formList[484].Min_Validation || 1}|max:${
                      formList[484].Max_Validation || 100
                    }|regex:${formList[484].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'customField1'"
                v-model="customField1"
                outlined
                :counter="formList[484].Max_Validation || 100"
                :maxlength="formList[484].Max_Validation || 100"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[484].Field_Alias }}
                  <span
                    v-if="formList[484].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Custom Field 2 -->
          <v-col
            v-if="formList[485] && formList[485].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="customField2Provider"
              v-slot="{ errors }"
              :name="formList[485].Field_Alias"
              :rules="
                formList[485].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[485].Min_Validation || 1}|max:${
                      formList[485].Max_Validation || 100
                    }|regex:${formList[485].Validation_Id || 5}`
                  : `min:${formList[485].Min_Validation || 1}|max:${
                      formList[485].Max_Validation || 100
                    }|regex:${formList[485].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'customField2'"
                v-model="customField2"
                outlined
                :counter="formList[485].Max_Validation || 100"
                :maxlength="formList[485].Max_Validation || 100"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[485].Field_Alias }}
                  <span
                    v-if="formList[485].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Custom Field 3 -->
          <v-col
            v-if="formList[486] && formList[486].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="customField3Provider"
              v-slot="{ errors }"
              :name="formList[486].Field_Alias"
              :rules="
                formList[486].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[486].Min_Validation || 1}|max:${
                      formList[486].Max_Validation || 100
                    }|regex:${formList[486].Validation_Id || 5}`
                  : `min:${formList[486].Min_Validation || 1}|max:${
                      formList[486].Max_Validation || 100
                    }|regex:${formList[486].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'customField3'"
                v-model="customField3"
                outlined
                :counter="formList[486].Max_Validation || 100"
                :maxlength="formList[486].Max_Validation || 100"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[486].Field_Alias }}
                  <span
                    v-if="formList[486].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Custom Field 4 -->
          <v-col
            v-if="formList[550] && formList[550].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="customField4Provider"
              v-slot="{ errors }"
              :name="formList[550].Field_Alias"
              :rules="
                formList[550].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[550].Min_Validation || 1}|max:${
                      formList[550].Max_Validation || 100
                    }|regex:${formList[550].Validation_Id || 5}`
                  : `min:${formList[550].Min_Validation || 1}|max:${
                      formList[550].Max_Validation || 100
                    }|regex:${formList[550].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'customField4'"
                v-model="customField4"
                outlined
                :counter="formList[550].Max_Validation || 100"
                :maxlength="formList[550].Max_Validation || 100"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[550].Field_Alias }}
                  <span
                    v-if="formList[550].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Custom Field 5 -->
          <v-col
            v-if="formList[551] && formList[551].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="customField5Provider"
              v-slot="{ errors }"
              :name="formList[551].Field_Alias"
              :rules="
                formList[551].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[551].Min_Validation || 1}|max:${
                      formList[551].Max_Validation || 100
                    }|regex:${formList[551].Validation_Id || 5}`
                  : `min:${formList[551].Min_Validation || 1}|max:${
                      formList[551].Max_Validation || 100
                    }|regex:${formList[551].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'customField5'"
                v-model="customField5"
                outlined
                :counter="formList[551].Max_Validation || 100"
                :maxlength="formList[551].Max_Validation || 100"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[551].Field_Alias }}
                  <span
                    v-if="formList[551].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Suffix -->
          <v-col
            v-if="formList[740] && formList[740].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="suffixProvider"
              v-slot="{ errors }"
              :name="formList[740].Field_Alias || 'Suffix'"
              :rules="
                formList[740].Mandatory_Field == 'Yes'
                  ? `required|max:10`
                  : `max:10`
              "
            >
              <v-text-field
                :id="'Suffix'"
                v-model="suffix"
                outlined
                :counter="10"
                :maxlength="10"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[740].Field_Alias || "Suffix" }}
                  <span
                    v-if="formList[740].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[232] && formList[232].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="knownAsProvider"
              v-slot="{ errors }"
              :name="formList[232].Field_Alias"
              :rules="
                formList[232].Mandatory_Field == 'Yes'
                  ? 'required|multilingualNameValidation|min:0|max:50'
                  : 'multilingualNameValidation|min:0|max:50'
              "
            >
              <v-text-field
                :id="'Emp_Pref_First_Name'"
                v-model="knownAs"
                outlined
                :counter="50"
                :maxlength="50"
                :label="formList[232].Field_Alias"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[232].Field_Alias }}
                  <span
                    v-if="formList[232].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[272] && formList[272].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="genderProvider"
              v-slot="{ errors }"
              name="Gender"
              :rules="formList[272].Mandatory_Field == 'Yes' ? 'required' : ''"
            >
              <v-autocomplete
                :id="'Gender'"
                v-model="gender"
                outlined
                :items="genderList"
                item-text="gender"
                item-value="genderId"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[272].Field_Alias }}
                  <span
                    v-if="formList[272].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[206] && formList[206].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="genderOrientationProvider"
              v-slot="{ errors }"
              :name="formList[206].Field_Alias"
              :rules="formList[206].Mandatory_Field == 'Yes' ? 'required' : ''"
            >
              <v-autocomplete
                :id="'GenderOrientation'"
                v-model="genderOrientation"
                item-text="Gender_Orientations_Name"
                item-value="Gender_Orientations_Name"
                outlined
                :items="genderOrientationList"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[206].Field_Alias }}
                  <span
                    v-if="formList[206].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[339] && formList[339].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="genderExpressionProvider"
              v-slot="{ errors }"
              :name="formList[339].Field_Alias"
              :rules="formList[339].Mandatory_Field == 'Yes' ? 'required' : ''"
            >
              <v-autocomplete
                :id="'GenderExpression'"
                v-model="genderExpression"
                outlined
                :items="genderExpressionList"
                item-text="Gender_Expression"
                item-value="Gender_Expression_Id"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[339].Field_Alias }}
                  <span
                    v-if="formList[339].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[338] && formList[338].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="genderIdentityProvider"
              v-slot="{ errors }"
              :name="formList[338].Field_Alias"
              :rules="formList[338].Mandatory_Field == 'Yes' ? 'required' : ''"
            >
              <v-autocomplete
                :id="'GenderIdentity'"
                v-model="genderIdentity"
                outlined
                :items="genderIdentityList"
                item-text="Gender_Identity"
                item-value="Gender_Identity_Id"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[338].Field_Alias }}
                  <span
                    v-if="formList[338].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[205] && formList[205].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="pronounProvider"
              v-slot="{ errors }"
              :name="formList[205].Field_Alias"
              :rules="formList[205].Mandatory_Field == 'Yes' ? 'required' : ''"
            >
              <v-autocomplete
                :id="'Pronoun'"
                v-model="pronoun"
                item-text="Gender_Pronoun_Name"
                item-value="Gender_Pronoun_Name"
                outlined
                :items="pronounList"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[205].Field_Alias }}
                  <span
                    v-if="formList[205].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
            <ValidationProvider>
              <v-dialog v-model="dobModal" width="290">
                <template #activator="{ on }">
                  <ValidationProvider
                    ref="dobProvider"
                    v-slot="{ errors }"
                    name="Date of Birth"
                    rules="required"
                  >
                    <v-text-field
                      :id="'DateOfBirth'"
                      :value="dateFormattedDob"
                      outlined
                      readonly
                      v-on="on"
                      :error-messages="errors"
                    >
                      <template v-slot:label>
                        Date of Birth<span style="color: red">*</span>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </template>
                <v-date-picker
                  v-if="dateOfBirth"
                  v-model="dateOfBirth"
                  :max="maxDob"
                  @change="saveDob(dateOfBirth)"
                >
                </v-date-picker>
                <v-date-picker
                  v-else
                  v-model="dobPresentation"
                  :max="maxDob"
                  @change="saveDobFromPresentation(dobPresentation)"
                >
                </v-date-picker>
              </v-dialog>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
            <ValidationProvider
              ref="maritalStatusProvider"
              v-slot="{ errors }"
              :name="maritalStatusLabel"
              rules="required"
            >
              <v-autocomplete
                :id="'MaritalStatus'"
                v-model="maritalStatus"
                outlined
                :items="maritalStatusList"
                item-text="Marital_Status"
                item-value="Marital_Status_Id"
                :label="maritalStatusLabel"
                @change="maritalStatusChange"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ maritalStatusLabel }}
                  <span style="color: red">*</span>
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <!-- Marriage Date -->
          <v-col
            v-if="presentMarriedDate"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider>
              <v-dialog v-model="marriageDateModel" width="290">
                <template #activator="{ on }">
                  <ValidationProvider
                    ref="marriageDateProvider"
                    v-slot="{ errors }"
                    :name="formList[787].Field_Alias"
                    :rules="
                      formList[787].Mandatory_Field.toLowerCase() === 'yes'
                        ? 'required'
                        : ''
                    "
                  >
                    <v-text-field
                      :id="'marriageDate'"
                      :value="dateFormattedMarriageDate"
                      outlined
                      readonly
                      v-on="on"
                      :error-messages="errors"
                    >
                      <template v-slot:label>
                        {{ formList[787].Field_Alias }}
                        <span
                          v-if="
                            formList[787].Mandatory_Field.toLowerCase() ===
                            'yes'
                          "
                          style="color: red"
                          >*</span
                        ></template
                      >
                    </v-text-field>
                  </ValidationProvider>
                </template>
                <v-date-picker
                  v-model="marriageDate"
                  :min="marriedMinDate"
                  :max="today"
                  @change="marriageDateModel = false"
                >
                </v-date-picker>
              </v-dialog>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[301] && formList[301].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="birthPlaceProvider"
              v-slot="{ errors }"
              :name="formList[301].Field_Alias"
              :rules="
                formList[301].Mandatory_Field == 'Yes'
                  ? 'required|birthPlace'
                  : 'birthPlace'
              "
            >
              <v-text-field
                :id="'PlaceOfBirth'"
                v-model="placeOfBirth"
                outlined
                :counter="50"
                :maxlength="50"
                label="Birth Place"
                required
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[301].Field_Alias }}
                  <span
                    v-if="formList[301].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            v-if="formList[400] && formList[400].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="bloodGroupsProvider"
              v-slot="{ errors }"
              :name="bloodGroupLabel"
              :rules="formList[400].Mandatory_Field == 'Yes' ? 'required' : ''"
            >
              <v-select
                :id="'BloodGroup'"
                v-model="bloodGroup"
                outlined
                :items="bloodGroupList"
                item-text="Blood_Group_Name"
                item-value="Blood_Group_Name "
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ bloodGroupLabel }}
                  <span
                    v-if="formList[400].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-select>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[379] && formList[379].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="languagesProvider"
              v-slot="{ errors }"
              :name="formList[379].Field_Alias"
              :rules="formList[379].Mandatory_Field == 'Yes' ? 'required' : ''"
            >
              <v-autocomplete
                :id="'Languages'"
                v-model="languages"
                outlined
                :items="languagesList"
                :search-input.sync="languageSearch"
                item-text="Language_Name"
                item-value="Lang_Id"
                multiple
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[379].Field_Alias }}
                  <span
                    v-if="formList[379].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
            <ValidationProvider
              ref="nationalityProvider"
              v-slot="{ errors }"
              name="Nationality"
              rules="required"
            >
              <v-autocomplete
                :id="'Nationality'"
                v-model="nationalityId"
                :loading="nationalityLoading"
                outlined
                :items="nationalityList"
                :search-input.sync="nationalitySearch"
                item-text="nationality"
                item-value="nationalityId"
                label="Nationality"
                :error-messages="errors"
              >
                <template v-slot:label>
                  Nationality<span style="color: red">*</span>
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="nationalityId == 11"
          >
            <ValidationProvider
              ref="otherNationality"
              v-slot="{ errors }"
              name="Other Nationality"
              rules="required"
            >
              <v-text-field
                :id="'OtherNationality'"
                v-model="nationality"
                label="Other Nationality*"
                outlined
                :counter="100"
                :maxlength="100"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
            <ValidationProvider
              ref="personalEmailProvider"
              v-slot="{ errors }"
              name="Personal Email"
              rules="email|required"
            >
              <v-text-field
                :id="'PersonalEmail'"
                v-model="personalEmail"
                outlined
                :counter="320"
                :maxlength="320"
                :error-messages="errors"
              >
                <template v-slot:label>
                  Personal Email<span style="color: red">*</span>
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            v-if="
              isAustralian &&
              formList[277] &&
              formList[277].Field_Visiblity == 'Yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <v-autocomplete
              :id="'EthnicRace'"
              v-model="aboriginal"
              label="Are you aboriginal or torres strait islander?"
              outlined
              :items="aboriginalList"
            ></v-autocomplete>
          </v-col>
          <!-- Tax Identification Number (PAN/TFN/SSN) -->
          <v-col
            v-if="
              !isAustralian &&
              formList[216] &&
              formList[216].Field_Visiblity == 'Yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="panNumberProvider"
              v-slot="{ errors }"
              :name="formList[216].Field_Alias"
              :rules="
                formList[216].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[216].Min_Validation || 1}|max:${
                      formList[216].Max_Validation || 30
                    }|regex:${formList[216].Validation_Id || 4}`
                  : `min:${formList[216].Min_Validation || 1}|max:${
                      formList[216].Max_Validation || 30
                    }|regex:${formList[216].Validation_Id || 4}`
              "
            >
              <v-text-field
                :id="'pan'"
                v-model="pan"
                outlined
                :counter="formList[216].Max_Validation || 30"
                :maxlength="formList[216].Max_Validation || 30"
                :label="formList[216].Field_Alias"
                @input="pan = pan.toUpperCase()"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[216].Field_Alias }}
                  <span
                    v-if="formList[216].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            v-if="
              !isAustralian &&
              formList[215] &&
              formList[215].Field_Visiblity == 'Yes'
            "
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="aadharNumberProvider"
              v-slot="{ errors }"
              :name="formList[215].Field_Alias"
              :rules="
                formList[215].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[215].Min_Validation || 2}|max:${
                      formList[215].Max_Validation || 25
                    }|regex:${formList[215].Validation_Id || 4}`
                  : `min:${formList[215].Min_Validation || 2}|max:${
                      formList[215].Max_Validation || 25
                    }|regex:${formList[215].Validation_Id || 4}`
              "
            >
              <v-text-field
                :id="'aadhar'"
                v-model="aadhar"
                outlined
                :counter="formList[215].Max_Validation || 25"
                :maxlength="formList[215].Max_Validation || 25"
                :label="formList[215].Field_Alias"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[215].Field_Alias }}
                  <span
                    v-if="formList[215].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Insurance No. -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[217] && formList[217].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="insuranceNoProvider"
              v-slot="{ errors }"
              :name="formList[217].Field_Alias"
              :rules="
                formList[217].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[217].Min_Validation || 1}|max:${
                      formList[217].Max_Validation || 15
                    }|regex:${formList[217].Validation_Id || 5}`
                  : `min:${formList[217].Min_Validation || 1}|max:${
                      formList[217].Max_Validation || 15
                    }|regex:${formList[217].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'insuranceNo'"
                v-model="insuranceNo"
                outlined
                :counter="formList[217].Max_Validation || 15"
                :maxlength="formList[217].Max_Validation || 15"
                :label="formList[217].Field_Alias"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[217].Field_Alias }}
                  <span
                    v-if="formList[217].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- NPS -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[218] && formList[218].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="npsProvider"
              v-slot="{ errors }"
              :name="formList[218].Field_Alias"
              :rules="
                formList[218].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[218].Min_Validation || 1}|max:${
                      formList[218].Max_Validation || 50
                    }|regex:${formList[218].Validation_Id || 5}`
                  : `min:${formList[218].Min_Validation || 1}|max:${
                      formList[218].Max_Validation || 50
                    }|regex:${formList[218].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'nps'"
                v-model="nps"
                outlined
                :counter="formList[218].Max_Validation || 50"
                :maxlength="formList[218].Max_Validation || 50"
                :label="formList[218].Field_Alias"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[218].Field_Alias }}
                  <span
                    v-if="formList[218].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[188] && formList[188].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="taxCodeProvider"
              v-slot="{ errors }"
              :name="formList[188].Field_Alias"
              :rules="
                formList[188].Mandatory_Field == 'Yes'
                  ? 'alphaNumSpaceWithFourSymbol|required'
                  : 'alphaNumSpaceWithFourSymbol'
              "
            >
              <v-autocomplete
                v-if="formList[188].Predefined == 'Yes'"
                :id="'TaxCode'"
                v-model="taxCode"
                :loading="taxCodeLoading"
                outlined
                :items="taxCodeList"
                :search-input.sync="taxCodeSearch"
                item-text="Tax_Description"
                item-value="Tax_Code"
                :label="formList[188].Field_Alias"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[188].Field_Alias }}
                  <span
                    v-if="formList[188].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
              <v-text-field
                v-else
                :id="'taxCode'"
                v-model="taxCode"
                outlined
                :maxlength="30"
                :label="formList[188].Field_Alias"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[188].Field_Alias }}
                  <span
                    v-if="formList[188].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- UAN -->
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[219] && formList[219].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="uanProvider"
              v-slot="{ errors }"
              :name="formList[219].Field_Alias"
              :rules="
                formList[219].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[219].Min_Validation || 1}|max:${
                      formList[219].Max_Validation || 25
                    }|regex:${formList[219].Validation_Id || 5}`
                  : `min:${formList[219].Min_Validation || 1}|max:${
                      formList[219].Max_Validation || 25
                    }|regex:${formList[219].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'uan'"
                v-model="uan"
                outlined
                :counter="formList[219].Max_Validation || 25"
                :maxlength="formList[219].Max_Validation || 25"
                :label="formList[219].Field_Alias"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[219].Field_Alias }}
                  <span
                    v-if="formList[219].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Custom Field 6 -->
          <v-col
            v-if="formList[552] && formList[552].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="customField6Provider"
              v-slot="{ errors }"
              :name="formList[552].Field_Alias"
              :rules="
                formList[552].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[552].Min_Validation || 1}|max:${
                      formList[552].Max_Validation || 100
                    }|regex:${formList[552].Validation_Id || 5}`
                  : `min:${formList[552].Min_Validation || 1}|max:${
                      formList[552].Max_Validation || 100
                    }|regex:${formList[552].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'customField6'"
                v-model="customField6"
                outlined
                :counter="formList[552].Max_Validation || 100"
                :maxlength="formList[552].Max_Validation || 100"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[552].Field_Alias }}
                  <span
                    v-if="formList[552].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Custom Field 7 -->
          <v-col
            v-if="formList[553] && formList[553].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="customField7Provider"
              v-slot="{ errors }"
              :name="formList[553].Field_Alias"
              :rules="
                formList[553].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[553].Min_Validation || 1}|max:${
                      formList[553].Max_Validation || 100
                    }|regex:${formList[553].Validation_Id || 5}`
                  : `min:${formList[553].Min_Validation || 1}|max:${
                      formList[553].Max_Validation || 100
                    }|regex:${formList[553].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'customField7'"
                v-model="customField7"
                outlined
                :counter="formList[553].Max_Validation || 100"
                :maxlength="formList[553].Max_Validation || 100"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[553].Field_Alias }}
                  <span
                    v-if="formList[553].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Custom Field 8 -->
          <v-col
            v-if="formList[554] && formList[554].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="customField8Provider"
              v-slot="{ errors }"
              :name="formList[554].Field_Alias"
              :rules="
                formList[554].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[554].Min_Validation || 1}|max:${
                      formList[554].Max_Validation || 100
                    }|regex:${formList[554].Validation_Id || 5}`
                  : `min:${formList[554].Min_Validation || 1}|max:${
                      formList[554].Max_Validation || 100
                    }|regex:${formList[554].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'customField8'"
                v-model="customField8"
                outlined
                :counter="formList[554].Max_Validation || 100"
                :maxlength="formList[554].Max_Validation || 100"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[554].Field_Alias }}
                  <span
                    v-if="formList[554].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Custom Field 9 -->
          <v-col
            v-if="formList[555] && formList[555].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="customField9Provider"
              v-slot="{ errors }"
              :name="formList[555].Field_Alias"
              :rules="
                formList[555].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[555].Min_Validation || 1}|max:${
                      formList[555].Max_Validation || 100
                    }|regex:${formList[555].Validation_Id || 5}`
                  : `min:${formList[555].Min_Validation || 1}|max:${
                      formList[555].Max_Validation || 100
                    }|regex:${formList[555].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'customField9'"
                v-model="customField9"
                outlined
                :counter="formList[555].Max_Validation || 100"
                :maxlength="formList[555].Max_Validation || 100"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[555].Field_Alias }}
                  <span
                    v-if="formList[555].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <!-- Custom Field 10 -->
          <v-col
            v-if="formList[556] && formList[556].Field_Visiblity == 'Yes'"
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
          >
            <ValidationProvider
              ref="customField10Provider"
              v-slot="{ errors }"
              :name="formList[556].Field_Alias"
              :rules="
                formList[556].Mandatory_Field == 'Yes'
                  ? `required|min:${formList[556].Min_Validation || 1}|max:${
                      formList[556].Max_Validation || 100
                    }|regex:${formList[556].Validation_Id || 5}`
                  : `min:${formList[556].Min_Validation || 1}|max:${
                      formList[556].Max_Validation || 100
                    }|regex:${formList[556].Validation_Id || 5}`
              "
            >
              <v-text-field
                :id="'customField10'"
                v-model="customField10"
                outlined
                :counter="formList[556].Max_Validation || 100"
                :maxlength="formList[556].Max_Validation || 100"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[556].Field_Alias }}
                  <span
                    v-if="formList[556].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            v-if="formList[376] && formList[376].Field_Visiblity == 'Yes'"
          >
            <div class="d-flex justify-space-between align-center mb-3">
              <div class="text-h6 font-weight-medium">Languages Known</div>
              <v-btn color="primary pa-0" text @click="addMoreLanguage()">
                <v-icon>add</v-icon>Add More
              </v-btn>
            </div>
            <v-form
              v-for="(language, index) in addLanguage"
              :key="index"
              :ref="'languageForm' + index"
            >
              <div
                v-if="addLanguage.length > 1"
                class="d-flex justify-end mb-3"
              >
                <v-btn
                  color="primary lighten-1"
                  text
                  @click="removeLanguage(index)"
                >
                  <v-icon>delete</v-icon>
                  Remove
                </v-btn>
              </div>
              <ValidationObserver :ref="'languageForm' + index">
                <v-row>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="6"
                    lg="6"
                    md="6"
                    xl="6"
                    v-if="
                      formList[376] && formList[376].Field_Visiblity == 'Yes'
                    "
                  >
                    <ValidationProvider
                      :ref="'language' + index"
                      v-slot="{ errors }"
                      :name="formList[376].Field_Alias"
                      :rules="
                        formList[376].Mandatory_Field == 'Yes' ? 'required' : ''
                      "
                    >
                      <v-autocomplete
                        :id="'languageName' + index"
                        v-model="language.Lang_Known"
                        outlined
                        :items="languagesList"
                        :search-input.sync="languageSearchArray[index]"
                        item-text="Language_Name"
                        item-value="Lang_Id"
                        :error-messages="errors"
                      >
                        <template v-slot:label>
                          {{ formList[376].Field_Alias }}
                          <span
                            style="color: red"
                            v-if="formList[376].Mandatory_Field == 'Yes'"
                            >*</span
                          >
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="6"
                    lg="6"
                    md="6"
                    xl="6"
                    v-if="
                      formList[365] && formList[365].Field_Visiblity == 'Yes'
                    "
                  >
                    <ValidationProvider
                      :ref="'proficiency' + index"
                      v-slot="{ errors }"
                      :name="formList[365].Field_Alias"
                      :rules="
                        formList[365].Mandatory_Field == 'Yes'
                          ? 'required|max:100'
                          : 'max:100'
                      "
                    >
                      <v-autocomplete
                        v-if="formList[365].Predefined == 'Yes'"
                        :id="'languageProficiency' + index"
                        v-model="language.Lang_Proficiency"
                        outlined
                        :items="languageProficiencyList"
                        :search-input.sync="languageProficiencyArray[index]"
                        item-text="Language_Proficiency"
                        item-value="Language_Proficiency"
                        :label="formList[365].Field_Alias"
                        :error-messages="errors"
                      >
                        <template v-slot:label>
                          {{ formList[365].Field_Alias }}
                          <span
                            v-if="formList[365].Mandatory_Field == 'Yes'"
                            style="color: red"
                            >*</span
                          >
                        </template>
                      </v-autocomplete>
                      <v-text-field
                        v-else
                        :id="'languageProficiency' + index"
                        v-model="language.Lang_Proficiency"
                        outlined
                        counter="100"
                        :error-messages="errors"
                        :label="formList[365].Field_Alias"
                      >
                        <template v-slot:label>
                          {{ formList[365].Field_Alias }}
                          <span
                            style="color: red"
                            v-if="formList[365].Mandatory_Field == 'Yes'"
                            >*</span
                          >
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="6"
                    lg="6"
                    md="6"
                    xl="6"
                    class="d-flex align-center"
                    v-if="
                      formList[363] && formList[363].Field_Visiblity == 'Yes'
                    "
                  >
                    <div
                      class="mb-0 mr-3"
                      style="color: #00000099; font-size: 0.9em"
                    >
                      {{ formList[363].Field_Alias }}
                    </div>
                    <v-switch
                      :id="'spoken'"
                      v-model="language.Lang_Spoken"
                      :true-value="1"
                      :false-value="0"
                      inset
                      color="primary"
                    >
                    </v-switch>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="6"
                    lg="6"
                    md="6"
                    xl="6"
                    class="d-flex align-center"
                    v-if="
                      formList[364] && formList[364].Field_Visiblity == 'Yes'
                    "
                  >
                    <div
                      class="mb-0 mr-3"
                      style="color: #00000099; font-size: 0.9em"
                    >
                      {{ formList[364].Field_Alias }}
                    </div>
                    <v-switch
                      :id="'readWrite' + index"
                      v-model="language.Lang_Read_Write"
                      :true-value="1"
                      :false-value="0"
                      inset
                      color="primary"
                    >
                    </v-switch>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </v-form>
          </v-col>
        </v-row>
        <v-row v-if="!isAustralian" class="ml-2">
          <v-col cols="12" class="text-h6 font-weight-medium">
            Other Information
          </v-col>
          <v-col cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
            <ValidationProvider
              ref="hobbiesProvider"
              v-slot="{ errors }"
              name="Hobbies"
              rules="alphaNumSpaceWithFourSymbol"
            >
              <v-text-field
                :id="'hobbies'"
                v-model="hobbies"
                outlined
                :counter="100"
                :maxlength="100"
                label="Hobbies"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[277] && formList[277].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="ethnicRaceProvider"
              v-slot="{ errors }"
              name="Ethnic Race"
              :rules="
                formList[277].Mandatory_Field == 'Yes'
                  ? 'required|alphaNumSpaceWithFourSymbol'
                  : 'alphaNumSpaceWithFourSymbol'
              "
            >
              <v-text-field
                :id="'aadhar'"
                v-model="ethnicRace"
                outlined
                :counter="30"
                :maxlength="30"
                :label="formList[277].Field_Alias"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[277].Field_Alias }}
                  <span
                    v-if="formList[277].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[302] && formList[302].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="religionProvider"
              v-slot="{ errors }"
              :name="formList[302].Field_Alias"
              :rules="formList[302].Mandatory_Field == 'Yes' ? 'required' : ''"
            >
              <v-autocomplete
                :id="'Religion'"
                v-model="religionId"
                outlined
                :items="religionList"
                :search-input.sync="religionSearch"
                item-text="religion"
                item-value="religionId"
                :error-messages="errors"
              >
                <template v-slot:label>
                  {{ formList[302].Field_Alias }}
                  <span
                    v-if="formList[302].Mandatory_Field == 'Yes'"
                    style="color: red"
                    >*</span
                  >
                </template>
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="religionId == 67"
          >
            <ValidationProvider
              ref="otherReligion"
              v-slot="{ errors }"
              name="Other Religion"
              rules="required"
            >
              <v-text-field
                :id="'OtherReligion'"
                v-model="religion"
                outlined
                :counter="100"
                :maxlength="100"
                :error-messages="errors"
              >
                <template v-slot:label>
                  Other Religion
                  <span style="color: red">*</span>
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            lg="6"
            md="6"
            xl="6"
            v-if="formList[241] && formList[241].Field_Visiblity == 'Yes'"
          >
            <ValidationProvider
              ref="casteProvider"
              v-slot="{ errors }"
              name="Caste"
              rules="alphaNumSpaceWithFourSymbol"
            >
              <v-text-field
                :id="'caste'"
                v-model="caste"
                outlined
                :counter="30"
                :maxlength="30"
                label="Caste"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col>
            <VueTelInput
              v-show="false"
              :autoDefaultCountry="true"
              @country-changed="getCountryCode($event)"
            ></VueTelInput>
          </v-col>
        </v-row>
        <v-row v-if="!isAustralian" class="ml-2">
          <v-col
            cols="12"
            xs="12"
            sm="4"
            lg="4"
            md="4"
            xl="4"
            class="d-flex align-center"
            v-if="formList[378] && formList[378].Field_Visiblity == 'Yes'"
          >
            <div class="mb-0 mr-3" style="color: #00000099; font-size: 0.9em">
              {{ formList[378].Field_Alias }}
            </div>
            <v-switch
              :id="'disability'"
              v-model="disability"
              inset
              color="primary"
            >
            </v-switch>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="4"
            lg="4"
            md="4"
            xl="4"
            class="d-flex align-center"
          >
            <p class="mb-0 mr-3" style="color: #00000099; font-size: 0.9em">
              Have you ever served in the military?
            </p>
            <v-switch
              :id="'militaryService'"
              v-model="militaryService"
              inset
              color="primary"
            ></v-switch>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="4"
            lg="4"
            md="4"
            xl="4"
            class="d-flex align-center"
          >
            <p class="mb-0 mr-3" style="color: #00000099; font-size: 0.9em">
              Are you a smoker?
            </p>
            <v-switch
              :id="'smokerProvider'"
              v-model="smoker"
              inset
              color="primary"
            ></v-switch>
          </v-col>
          <v-col v-if="smoker" cols="12" xs="12" sm="6" lg="6" md="6" xl="6">
            <v-dialog v-model="smokerasofModel" width="290">
              <template #activator="{ on }">
                <ValidationProvider
                  ref="smokerasofprovider"
                  v-slot="{ errors }"
                  name="Smoker as of"
                >
                  <v-text-field
                    :id="'smokerasof'"
                    outlined
                    :value="formatDate(smokerasof)"
                    label="Smoker as of"
                    :disabled="!smoker"
                    v-on="on"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </template>
              <v-date-picker
                v-model="smokerasof"
                :max="today"
                @change="smokerasofModel = false"
              ></v-date-picker>
            </v-dialog>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-form>
    <v-overlay absolute :value="formListLoader" color="#fff" z-index="1">
      <v-progress-circular
        color="primary"
        indeterminate
        size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import {
  LIST_RELATIONSHIP,
  LIST_MARITAL_STATUS,
  LIST_LANGUAGE,
  LIST_NATIONALITY,
  LIST_RELIGION,
  LIST_GENDERS,
  GET_FORM_FIELDS_AND_TYPE,
  LIST_TAX_CODES,
  RETRIEVE_DROPDOWN_DETAILS,
} from "@/graphql/OnboardingQueries";
import moment from "moment";
import { VueTelInput } from "vue-tel-input";

export default {
  name: "BasicInformation",

  components: { VueTelInput },

  props: {
    personalInfo: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    // fields
    religionSearch: "",
    languageSearch: "",
    languageSearchArray: [""],
    languageProficiencyArray: [""],
    nationalitySearch: "",
    taxCodeSearch: "",
    salutation: "",
    firstName: "",
    lastName: "",
    middleName: "",
    knownAs: "",
    dateOfBirth: "",
    marriageDate: null,
    dobPresentation: "",
    placeOfBirth: "",
    gender: null,
    maritalStatus: null,
    bloodGroup: "",
    languages: [],
    nationality: "",
    nationalityId: "",
    personalEmail: "",
    aboriginal: "",
    pan: "",
    aadhar: "",
    hobbies: "",
    ethnicRace: "",
    caste: "",
    religion: "",
    religionId: "",
    insuranceNo: "",
    nps: "",
    pronoun: "",
    genderOrientation: "",
    disability: false,
    smoker: false,
    militaryService: false,
    smokerasof: "",
    smokerasofModel: false,
    suffix: "",
    customField1: "",
    customField2: "",
    customField3: "",
    customField4: "",
    customField5: "",
    customField6: "",
    customField7: "",
    customField8: "",
    customField9: "",
    customField10: "",
    isLoading: false,
    formListLoader: false,
    uan: null,
    taxCode: null,
    genderExpression: null,
    genderIdentity: null,
    addLanguage: [
      {
        Lang_Known: null,
        Lang_Proficiency: "",
        Lang_Spoken: 0,
        Lang_Read_Write: 0,
      },
    ],

    // list
    formList: {},
    maritalStatusList: [],
    genderList: [],
    taxCodeList: [],
    genderIdentityList: [],
    genderExpressionList: [],
    languageProficiencyList: [],
    genderOrientationList: [],
    pronounList: [],
    salutationList: ["Mr", "Miss", "Mrs", "Dr", "Prof", "Ms"],
    bloodGroupList: [],
    languagesList: [],
    nationalityList: [],
    religionList: [],
    aboriginalList: [
      "Aboriginal",
      "Aboriginal/Torres Strait Islander",
      "Neither Aboriginal nor Torres Strait Islander",
      "Torres Strait Islander",
    ],

    // others
    dobModal: false,
    marriageDateModel: false,
    countryCode: "",
  }),

  watch: {
    languages() {
      this.languageSearch = "";
    },
    nationalityId() {
      this.nationalitySearch = "";
    },
    religionId() {
      this.religionSearch = "";
    },
  },

  apollo: {
    listTimekeepingCareerDetail: {
      query: LIST_TAX_CODES,
      client: "apolloClientB",
      result({ data }) {
        if (
          data &&
          data.listTimekeepingCareerDetail &&
          data.listTimekeepingCareerDetail.taxDetail &&
          data.listTimekeepingCareerDetail.taxDetail.length > 0
        ) {
          this.taxCodeList = data.listTimekeepingCareerDetail.taxDetail;
        }
      },
    },
    retrieveGenderList: {
      query: LIST_GENDERS,
      variables() {
        return {
          Org_Code: localStorage.getItem("orgCode"),
        };
      },
      result({ data }) {
        if (
          data &&
          data.retrieveGenderList &&
          data.retrieveGenderList.genderData
        ) {
          this.genderList = data.retrieveGenderList.genderData;
        }
      },
    },
    listMartialStatus: {
      query: LIST_MARITAL_STATUS,
      client: "apolloClientA",
      variables() {
        return {
          Org_Code: localStorage.getItem("orgCode"),
          Url_Hash: localStorage.getItem("urlHash"),
        };
      },
      result({ data }) {
        if (data && data.listMartialStatus) {
          this.maritalStatusList = data.listMartialStatus.marital_status;
        }
      },
    },
    listLanguage: {
      query: LIST_LANGUAGE,
      client: "apolloClientA",
      variables() {
        return {
          Org_Code: localStorage.getItem("orgCode"),
          Url_Hash: localStorage.getItem("urlHash"),
        };
      },
      result({ data }) {
        if (data && data.listLanguage) {
          this.languagesList = data.listLanguage.languages;
        }
      },
    },
    retrieveNationalityList: {
      query: LIST_NATIONALITY,
      client: "apolloClientA",
      variables() {
        return {
          Org_Code: localStorage.getItem("orgCode"),
        };
      },
      result({ data }) {
        if (data && data.retrieveNationalityList) {
          this.nationalityList = data.retrieveNationalityList.nationalityData;
          if (!this.nationality && !this.nationalityId) {
            this.assignNationalityBasedOnCode();
          }
        }
      },
    },
    retrieveReligionList: {
      query: LIST_RELIGION,
      client: "apolloClientA",
      variables() {
        return {
          Org_Code: localStorage.getItem("orgCode"),
        };
      },
      result({ data }) {
        if (data && data.retrieveReligionList) {
          this.religionList = data.retrieveReligionList.religionData;
        }
        // this.isLoading = false;
      },
    },
    retrieveDropdownDetails: {
      query: RETRIEVE_DROPDOWN_DETAILS,
      client: "apolloClientD",
      variables() {
        return {
          formId: 178,
          key: [
            "Gender_Identity_Id",
            "Gender_Expression_Id",
            "gender_pronoun",
            "gender_orientations",
            "language_proficiency",
            "blood_group",
          ],
        };
      },
      result({ data }) {
        if (data && data.retrieveDropdownDetails) {
          let { dropdownDetails } = data.retrieveDropdownDetails;
          dropdownDetails = JSON.parse(dropdownDetails);
          for (let list of dropdownDetails) {
            if (list.tableKey === "Gender_Identity_Id") {
              this.genderIdentityList = list.data;
            } else if (list.tableKey === "Gender_Expression_Id") {
              this.genderExpressionList = list.data;
            } else if (list.tableKey === "language_proficiency") {
              this.languageProficiencyList = list.data;
            } else if (list.tableKey === "gender_pronoun") {
              this.pronounList = list.data;
            } else if (list.tableKey === "gender_orientations") {
              this.genderOrientationList = list.data;
            } else if (list.tableKey === "blood_group") {
              this.bloodGroupList = list.data;
            }
          }
        }
      },

      error(err) {
        let snackbarData = {
          isOpen: true,
          message:
            err.graphQLErrors.length !== 0
              ? err.graphQLErrors[0].message
              : "Something went wrong. It could be a possibility due to network connectivity error..",
          type: "warning",
        };
        this.showAlert(snackbarData);
      },
    },
  },

  computed: {
    firstNameLabel() {
      return this.formList[694] && this.formList[694].Field_Alias
        ? this.formList[694].Field_Alias
        : "First Name";
    },
    maritalStatusLabel() {
      return this.formList[398] && this.formList[398].Field_Alias
        ? this.formList[398].Field_Alias
        : "Marital Status";
    },
    bloodGroupLabel() {
      return this.formList[400] && this.formList[400].Field_Alias
        ? this.formList[400].Field_Alias
        : "Blood Group";
    },
    nationalityLoading() {
      return this.$apollo.queries.retrieveNationalityList.loading;
    },
    taxCodeLoading() {
      return this.$apollo.queries.listTimekeepingCareerDetail.loading;
    },
    today() {
      return moment().format("YYYY-MM-DD");
    },
    formatDate() {
      return (date) => {
        return date ? moment(date).format("DD/MM/YYYY") : "";
      };
    },
    isAustralian() {
      let country = localStorage.getItem("country");
      if (country && country.toLowerCase() === "au") {
        return true;
      }
      return false;
    },
    dateFormattedDob() {
      return this.dateOfBirth
        ? moment(this.dateOfBirth).format("DD/MM/YYYY")
        : "";
    },
    dateFormattedMarriageDate() {
      return this.marriageDate
        ? moment(this.marriageDate).format("DD/MM/YYYY")
        : "";
    },
    presentMarriedDate() {
      return (
        this.formList[787] &&
        this.formList[787].Field_Visiblity.toLowerCase() === "yes" &&
        this.maritalStatusList
          ?.find((el) => el.Marital_Status_Id == this.maritalStatus)
          ?.Marital_Status?.toLowerCase() === "married"
      );
    },
    marriedMinDate() {
      return this.dateOfBirth
        ? moment(this.dateOfBirth).format("YYYY-MM-DD")
        : null;
    },
    maxDob() {
      let currentDate = new Date();
      let currentMonth = (currentDate.getMonth() + 1).toString();
      let currentDay = (currentDate.getDate() - 1).toString();
      if (currentMonth.length == 1) {
        currentMonth = "0" + currentMonth;
      }
      if (currentDay.length == 1) {
        currentDay = "0" + currentDay;
      }
      return (
        currentDate.getFullYear() - 15 + "-" + currentMonth + "-" + currentDay
      );
    },
  },
  beforeMount() {
    this.getFieldProps();
  },
  mounted() {
    this.isLoading = true;
    this.dobPresentation = moment().subtract(15, "years").format("YYYY-MM-DD");
    if (this.personalInfo && Object.keys(this.personalInfo).length > 0) {
      this.salutation = this.personalInfo.Salutation?.trim();
      this.firstName = this.personalInfo.Emp_First_Name?.trim();
      this.lastName = this.personalInfo.Emp_Last_Name?.trim();
      this.middleName = this.personalInfo.Emp_Middle_Name?.trim();
      this.knownAs = this.personalInfo.Emp_Pref_First_Name?.trim();
      this.suffix = this.personalInfo.Appellation?.trim();
      this.dateOfBirth = this.personalInfo.DOB;
      this.marriageDate = this.personalInfo.Marriage_Date
        ? moment(this.personalInfo.Marriage_Date).format("YYYY-MM-DD")
        : null;
      this.placeOfBirth = this.personalInfo.Place_Of_Birth?.trim();
      this.gender = this.personalInfo.Gender_Id;
      this.maritalStatus = this.personalInfo.Marital_Status;
      this.bloodGroup = this.personalInfo.Blood_Group;
      this.genderExpression = this.personalInfo.Gender_Expression_Id;
      this.genderIdentity = this.personalInfo.Gender_Identity_Id;
      let langKnown = [];
      if (this.personalInfo.Lang_Known?.length) {
        langKnown = this.personalInfo.Lang_Known.map((item) => ({
          Lang_Id: item.Lang_Known,
          Lang_Known: item.Lang_Known,
          Lang_Spoken: item.Lang_Spoken || null,
          Lang_Read_Write: item.Lang_Read_Write || null,
          Lang_Proficiency: item.Lang_Proficiency || null,
        }));
      }
      if (this.personalInfo.Lang_Known?.length) {
        this.addLanguage = langKnown.map((obj) => {
          let { Lang_Known, Lang_Spoken, Lang_Read_Write, Lang_Proficiency } =
            obj;
          return {
            Lang_Known,
            Lang_Spoken,
            Lang_Read_Write,
            Lang_Proficiency,
          };
        });
      } else {
        this.addLanguage = [
          {
            Lang_Known: null,
            Lang_Spoken: 0,
            Lang_Read_Write: 0,
            Lang_Proficiency: "",
          },
        ];
      }

      this.languages = langKnown.map((obj) => {
        return obj.Lang_Id;
      });
      this.nationalityId = this.personalInfo.Nationality_Id;
      this.nationality = this.personalInfo.Nationality;
      if (!this.nationalityId && !this.nationality) {
        this.assignNationalityBasedOnCode();
      }
      this.personalEmail = this.personalInfo.Personal_Email?.trim();
      this.aboriginal = this.personalInfo.Ethnic_Race;
      this.pan = this.personalInfo.PAN;
      this.aadhar = this.personalInfo.Aadhaar_Card_Number;
      this.hobbies = this.personalInfo.hobbies;
      this.ethnicRace = this.personalInfo.Ethnic_Race;
      this.caste = this.personalInfo.Caste;
      this.religionId = this.personalInfo.Religion_Id;
      this.religion = this.personalInfo.Religion;
      this.disability = this.personalInfo.Physically_Challenged;
      this.militaryService = this.personalInfo.Military_Service;
      this.smoker = this.personalInfo.Smoker;
      this.smokerasof = this.personalInfo.Smokerasof;
      this.genderOrientation = this.personalInfo.Gender_Orientations;
      this.pronoun = this.personalInfo.Pronoun;
      this.insuranceNo = this.personalInfo.Statutory_Insurance_Number;
      this.nps = this.personalInfo.PRAN_No;
      this.uan = this.personalInfo.UAN;
      this.taxCode = this.personalInfo.Tax_Code;
      this.customField1 = this.personalInfo.Custom_Field_1;
      this.customField2 = this.personalInfo.Custom_Field_2;
      this.customField3 = this.personalInfo.Custom_Field_3;
      this.customField4 = this.personalInfo.Custom_Field_4;
      this.customField5 = this.personalInfo.Custom_Field_5;
      this.customField6 = this.personalInfo.Custom_Field_6;
      this.customField7 = this.personalInfo.Custom_Field_7;
      this.customField8 = this.personalInfo.Custom_Field_8;
      this.customField9 = this.personalInfo.Custom_Field_9;
      this.customField10 = this.personalInfo.Custom_Field_10;
      localStorage.setItem("DOB", this.dateOfBirth);
    }
    this.isLoading = false;
    this.maritalStatusChange("mounted");
  },

  methods: {
    assignNationalityBasedOnCode() {
      let nationalityIdList = this.nationalityList.map((ele) => {
        return ele.nationalityId;
      });
      if (this.defaultCountryCode == "in") {
        if (nationalityIdList.includes(12)) {
          this.editedPersonalDetails.Nationality_Id = 12;
          this.editedPersonalDetails.Nationality = "Indian";
        }
      } else if (this.defaultCountryCode == "ph") {
        if (nationalityIdList.includes(3)) {
          this.editedPersonalDetails.Nationality_Id = 3;
          this.editedPersonalDetails.Nationality = "Filipino";
        }
      } else if (this.defaultCountryCode == "id") {
        if (nationalityIdList.includes(5)) {
          this.editedPersonalDetails.Nationality_Id = 5;
          this.editedPersonalDetails.Nationality = "Indonesian";
        }
      } else if (this.defaultCountryCode == "th") {
        if (nationalityIdList.includes(9)) {
          this.editedPersonalDetails.Nationality_Id = 9;
          this.editedPersonalDetails.Nationality = "Thai";
        }
      }
    },
    getCountryCode(code) {
      this.countryCode = code;
    },
    getFieldProps() {
      let vm = this;
      vm.formListLoader = true;
      this.$apollo
        .query({
          query: GET_FORM_FIELDS_AND_TYPE,
          variables: {
            form_Id: 178,
          },
          client: "apolloClientB",
        })
        .then((res) => {
          if (
            res.data.getFormFeildsByFormIdAndTab &&
            res.data.getFormFeildsByFormIdAndTab.formFields &&
            res.data.getFormFeildsByFormIdAndTab.formFields.length > 0
          ) {
            res.data.getFormFeildsByFormIdAndTab.formFields.forEach((list) => {
              this.formList[list.Field_Id] = list;
            });
          }
          vm.formListLoader = false;
        })
        .catch(() => {
          vm.formListLoader = false;
        });
    },
    basicInfoFields() {
      let religionValue = "",
        nationalityValue = "";
      let selectedReligion = this.religionList.filter(
        (el) => el.religionId == this.religionId
      );
      if (selectedReligion && selectedReligion.length > 0) {
        religionValue = selectedReligion[0].religion;
      }
      let selectedNationality = this.nationalityList.filter(
        (el) => el.nationalityId == this.nationalityId
      );
      if (selectedNationality && selectedNationality.length > 0) {
        nationalityValue = selectedNationality[0].nationality;
      }
      let genderTitle = this.genderList.filter((e) => {
        if (e.genderId == this.gender) {
          return e.gender;
        }
      });
      let langArray = [];
      let languagesKnown = [];
      langArray = this.languages;
      languagesKnown = langArray.map((langId) => ({
        Lang_Known: langId,
        Lang_Spoken: null,
        Lang_Read_Write: null,
        Lang_Proficiency: null,
      }));
      return {
        Salutation: this.salutation?.trim(),
        Emp_First_Name: this.firstName?.trim(),
        Emp_Middle_Name: this.middleName?.trim(),
        Emp_Last_Name: this.lastName?.trim(),
        Emp_Pref_First_Name: this.knownAs?.trim(),
        Gender_Id: this.gender,
        DOB:
          this.dateOfBirth && this.dateOfBirth != "Invalid date"
            ? this.dateOfBirth
            : null,
        Place_Of_Birth: this.placeOfBirth?.trim(),
        Marital_Status: this.maritalStatus,
        Marriage_Date: this.marriageDate,
        Blood_Group: this.bloodGroup,
        Lang_Known:
          this.formList[376] && this.formList[376].Field_Visiblity == "Yes"
            ? this.addLanguage
            : languagesKnown,
        hobbies: this.hobbies,
        Nationality:
          this.nationalityId == 11 ? this.nationality : nationalityValue,
        Nationality_Id: this.nationalityId,
        Religion: this.religionId == 67 ? this.religion : religionValue,
        Religion_Id: this.religionId,
        Caste: this.caste,
        Is_Manager: false,
        Personal_Email: this.personalEmail?.trim(),
        Physically_Challenged: this.disability,
        Smoker: this.smoker,
        Smokerasof:
          this.smoker && this.smokerasof && this.smokerasof != "Invalid date"
            ? this.smokerasof
            : null,
        PAN: this.pan,
        Aadhaar_Card_Number: this.aadhar,
        Military_Service: this.militaryService,
        Ethnic_Race: this.ethnicRace ? this.ethnicRace : this.aboriginal,
        Appellation: this.suffix?.trim(),
        Gender_Orientations: this.genderOrientation,
        Pronoun: this.pronoun,
        UAN: this.uan,
        Statutory_Insurance_Number: this.insuranceNo,
        PRAN_No: this.nps,
        Gender: genderTitle[0].gender,
        Tax_Code: this.taxCode,
        Gender_Expression_Id: this.genderExpression,
        Gender_Identity_Id: this.genderIdentity,
        No_Dependent: this.personalInfo.No_Dependent,
        Relative_In_Company: this.personalInfo.No_Dependent,
        Personal_Custom_Field1: this.customField1,
        Personal_Custom_Field2: this.customField2,
        Personal_Custom_Field3: this.customField3,
        Personal_Custom_Field4: this.customField4,
        Personal_Custom_Field5: this.customField5,
        Personal_Custom_Field6: this.customField6,
        Personal_Custom_Field7: this.customField7,
        Personal_Custom_Field8: this.customField8,
        Personal_Custom_Field9: this.customField9,
        Personal_Custom_Field10: this.customField10,
      };
    },
    saveDob(value) {
      localStorage.setItem("DOB", value);
      this.dobModal = false;
    },
    saveDobFromPresentation(value) {
      this.dateOfBirth = value;
      localStorage.setItem("DOB", value);
      this.dobModal = false;
    },
    maritalStatusChange(from = "") {
      let vm = this;
      if (from !== "mounted") vm.marriageDate = null;
      vm.$apollo
        .query({
          query: LIST_RELATIONSHIP,
          variables: {
            Org_Code: localStorage.getItem("orgCode"),
            Url_Hash: localStorage.getItem("urlHash"),
          },
          client: "apolloClientA",
        })
        .then((res) => {
          if (res.data) {
            const { marital_status_relation } =
              res.data.listMartialStatusRelation;
            vm.$emit("relationship-list", marital_status_relation);
          }
        });
    },
    salutationListChange() {
      this.gender =
        this.salutation === "Mr"
          ? 1
          : this.salutation === "Miss" || this.salutation === "Mrs"
          ? 0
          : null;
    },
    validateBasicInfo() {
      return new Promise((resolve) => {
        this.$refs.basicInfoValidationObserver
          .validate()
          .then((validationResponse) => {
            let invalidFields = [];
            Object.keys(this.$refs).forEach((refName) => {
              const field = this.$refs[refName];
              if (field && field.errors && field.errors.length > 0) {
                invalidFields.push(refName);
              }
            });
            if (invalidFields.length > 0) {
              let firstField = this.$refs[invalidFields[0]];
              firstField.$el.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
            resolve(validationResponse);
          });
      });
    },
    addMoreLanguage() {
      this.validateLanguages().then((isValid) => {
        if (isValid) {
          this.addLanguage.push({
            Lang_Known: null,
            Lang_Spoken: 0,
            Lang_Read_Write: 0,
            Lang_Proficiency: "",
          });
          this.languageSearchArray.push("");
          this.languageProficiencyArray.push("");
        }
      });
    },

    validateLanguages() {
      return new Promise((resolve) => {
        let callCount = 0,
          isValidCount = 0;
        for (let aIndex in this.addLanguage) {
          this.$refs["languageForm" + aIndex][0]
            .validate()
            .then((validationResponse) => {
              callCount += 1;
              if (validationResponse) {
                isValidCount += 1;
                if (callCount === this.addLanguage.length) {
                  resolve(isValidCount === this.addLanguage.length);
                }
              }
            });
        }
      });
    },

    removeLanguage(index) {
      this.addLanguage.splice(index, 1);
      this.languageSearchArray.splice(index, 1);
      this.languageProficiencyArray.splice(index, 1);
    },
  },
};
</script>
